/**
 * 交班账务
 */
import React from 'react';
import { Tabs } from 'antd';
import intl from 'react-intl-universal';

import { HandoverInfo } from '@/pages/handover/helper';

import SummaryTab from '../SummaryTab';
import RoomTab from '../RoomTab';
import ReceptionTab from '../ReceptionTab';
import CardTab from '../CardTab';
import RechargeTab from '../RechargeTab';
import DetailTab from '../DetailTab';

interface IProps {
  handoverInfo: HandoverInfo;
}

const Index: React.FC<IProps> = (props) => {
  const { handoverInfo } = props;
  return (
    <div>
      <Tabs
        destroyInactiveTabPane
        tabPosition="left"
        items={[
          {
            key: intl.get('handover_bill_category_summary_tab'),
            label: intl.get('handover_bill_category_summary_tab'),
            children: <SummaryTab handoverInfo={handoverInfo} />,
          },
          {
            key: intl.get('handover_bill_category_room_tab'),
            label: intl.get('handover_bill_category_room_tab'),
            children: <RoomTab />,
          },
          {
            key: intl.get('handover_bill_category_reception_tab'),
            label: intl.get('handover_bill_category_reception_tab'),
            children: <ReceptionTab />,
          },
          {
            key: intl.get('handover_bill_category_card_tab'),
            label: intl.get('handover_bill_category_card_tab'),
            children: <CardTab />,
          },
          {
            key: intl.get('handover_bill_category_recharge_tab'),
            label: intl.get('handover_bill_category_recharge_tab'),
            children: <RechargeTab />,
          },
          {
            key: intl.get('handover_bill_category_detail_tab'),
            label: intl.get('handover_bill_category_detail_tab'),
            children: <DetailTab handoverInfo={handoverInfo} />,
          },
        ]}
      />
    </div>
  );
};

export default Index;
